import strings from '../../../../../../../common/Translation/Translate';

export const normalizeTime = (value: string) => (value?.length === 5 ? value : value?.slice(0, 5) ?? '');

export type VenueConfigTimeslotRow = {
  id?: number;
  startTime: string;
  endTime: string;
};

export type TimeslotMinimumRevenueRow = {
  id?: number;
  startTime: string;
  endTime: string;
  minimumRevenue: string | number;
};

export const validateVenueConfigTimeslotRow = (row: VenueConfigTimeslotRow): string => {
  const start = normalizeTime(String(row.startTime ?? ''));
  const end = normalizeTime(String(row.endTime ?? ''));
  if (!start || !end) {
    return strings.requiredText;
  }
  if (start >= end) {
    return strings.venueConfig_timeslot_end_after_start;
  }
  return '';
};

export const validateTimeslotMinimumRevenueRow = (row: TimeslotMinimumRevenueRow): string => {
  const start = normalizeTime(String(row.startTime ?? ''));
  const end = normalizeTime(String(row.endTime ?? ''));
  const revenueStr = String(row.minimumRevenue ?? '').trim();
  if (!start || !end || !revenueStr) {
    return strings.requiredText;
  }
  const revenue = parseFloat(revenueStr);
  if (Number.isNaN(revenue) || revenue < 0) {
    return strings.requiredText;
  }
  if (start >= end) {
    return strings.venueConfig_timeslot_end_after_start;
  }
  return '';
};

export const mapVenueConfigTimeslotsFromApi = (items: any[] = []): VenueConfigTimeslotRow[] =>
  items.map(item => ({
    id: item.id,
    startTime: normalizeTime(item.startTime ?? ''),
    endTime: normalizeTime(item.endTime ?? ''),
  }));

export const mapDefaultVenueConfigTimeslotsFromDefaults = (defaults?: {
  venueConfigTimeslots?: any[];
}): VenueConfigTimeslotRow[] => mapVenueConfigTimeslotsFromApi(defaults?.venueConfigTimeslots ?? []);

export const mapTimeslotMinimumRevenuesFromApi = (items: any[] = []): TimeslotMinimumRevenueRow[] =>
  items.map(item => ({
    id: item.id,
    startTime: normalizeTime(item.startTime ?? ''),
    endTime: normalizeTime(item.endTime ?? ''),
    minimumRevenue: item.minimumRevenue ?? '',
  }));

export const buildVenueConfigTimeslotsPayload = (rows: VenueConfigTimeslotRow[]) =>
  rows
    .filter(row => normalizeTime(String(row.startTime)) && normalizeTime(String(row.endTime)))
    .map(row => ({
      id: row.id,
      startTime: normalizeTime(String(row.startTime)),
      endTime: normalizeTime(String(row.endTime)),
    }));

export const buildTimeslotMinimumRevenuesPayload = (rows: TimeslotMinimumRevenueRow[]) =>
  rows
    .filter(row => normalizeTime(String(row.startTime)) && normalizeTime(String(row.endTime)))
    .map(row => ({
      id: row.id,
      startTime: normalizeTime(String(row.startTime)),
      endTime: normalizeTime(String(row.endTime)),
      minimumRevenue: parseFloat(String(row.minimumRevenue)),
    }));

export const validateVenueConfigTimeslots = (rows: VenueConfigTimeslotRow[]): string => {
  if (rows.length === 0) {
    return strings.timeslotRequired;
  }
  for (const row of rows) {
    const error = validateVenueConfigTimeslotRow(row);
    if (error) return error;
  }
  return '';
};

export const validateTimeslotMinimumRevenues = (rows: TimeslotMinimumRevenueRow[]): string => {
  for (const row of rows) {
    const error = validateTimeslotMinimumRevenueRow(row);
    if (error) return error;
  }
  return '';
};
